import React from 'react';
import NavBar from './Navbar';
import Header from './Header';
import About from './About';
import Resume from './Resume';
import PublicationsList from './PublicationsList.js';
import CertificateList from './CertificateList';
import Contact from './Contact';
import Footer from './Footer';
import SkillsAndProjects from './SkillsAndProjects';
import AccessibilityWidget from './AccessibilityWidget';
import ScrollToTop from './ScrollToTop';
import 'font-awesome/css/font-awesome.min.css';
import {publications} from '../data/publications.js';
import {certificates} from '../data/certificates.js';
// Custom styles for smooth section transitions
const portfolioStyles = `
  .smooth-transition {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .smooth-transition + .smooth-transition {
    margin-top: 0 !important; /* Removed negative margin */
  }

  /* Ensure no gaps between sections */
  section {
    margin-top: 0;
  }

  #about {
    margin-top: 0; /* Remove gap between header and about */
    position: relative;
    z-index: 5; /* Lower than header elements */
  }

  /* Smooth scrolling for the entire page */
  html {
    scroll-behavior: smooth;
    scroll-padding-top: 4rem; /* Account for fixed navbar */
  }

  /* Reduce any default margins */
  .container, .row, .col-md-12 {
    margin-top: 0;
  }

  /* Ensure header elements stay visible */
  #header {
    position: relative;
    z-index: 10;
    margin-bottom: 0; /* Remove any default margins */
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = portfolioStyles;
  if (!document.head.querySelector('[data-portfolio-smooth-styles]')) {
    styleElement.setAttribute('data-portfolio-smooth-styles', 'true');
    document.head.appendChild(styleElement);
  }
}

function Portfolio() {
  return (
    <div className="smooth-transitions-container">
      {/* Skip to main content link for accessibility */}
      <a
        href="#about"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        Skip to main content
      </a>

      {/* Navigation Bar - Fixed top navigation */}
      <NavBar />

      <main>
        {/* Hero Section - Main landing/intro area */}
        <Header className="smooth-transition" srcset="assets/images/cover.png 400w, /path/to/image-medium.jpg 800w, /path/to/image-large.jpg 1200w" sizes="(max-width: 400px) 400px, (max-width: 800px) 800px, 1200px" />

        {/* Main Content Sections */}
        <About className="smooth-transition" />
        <PublicationsList className="smooth-transition" publications={publications}/>
        <Resume className="smooth-transition" />
        <section id="skills-projects" className="smooth-transition">
          <SkillsAndProjects />
        </section>
        <CertificateList className="smooth-transition" certificates={certificates} />
        <Contact className="smooth-transition" />
      </main>

      <Footer className="smooth-transition" />

      {/* Accessibility Widget */}
      <AccessibilityWidget />

      {/* Scroll to Top Button */}
      <ScrollToTop />
    </div>
  );
}

export default Portfolio;
